/*
 * Module for the Estimated Benefit Step of the shared wizards
*/
rs.module("content/communications/onlineforms/sharedformsteps/estimatedbenefitstep",

    [
        "controls/navigation/wizard",
        "controls/components/event-banner"
    ],

    function (wizard, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner);
            var generateButton = stepContainer.js(jsSelectors.generateButton);
            var estimateDetail = stepContainer.js(jsSelectors.estimateDetail, { required: false });

            generateButton.click(function () {
                loadingSpinner.show();
                eventBanner.addInformationalMessages(`Please wait while we generate your estimate. Please do not navigate away from this step.`)

                $.get(
                    {
                        url: backendUrls.generateBenefitEstimate,
                        headers: wizard.getNavigationToken()
                    }).done(function (html) {
                        estimateDetail.html(html);
                        estimateDetail.show();
                    }).always(function () {
                        loadingSpinner.hide();
                        eventBanner.removeAllMessages();
                    }).fail(function (xhr) {
                        console.error(xhr.status, xhr.responseText);
                    });
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);